<p-dialog header="{{ 'fs.res.common.organizations.external.create' | hisUi }}" [(visible)]="visibility" [modal]="true" height="auto" (onHide)="closeDialog()" [draggable]="false" [blockScroll]="true">

	<div class="layoutBlock">
		<div class="columnFullWidth">
			<res-external-organization-create
				[researchPartner]="researchPartner">
			</res-external-organization-create>
		</div>
	</div>

	<p-footer>
		<button (click)="saveDialog()" (keydown.tab)="$event.preventDefault(); $event.stopPropagation(); cancelBtn.focus();"><span>{{ 'common.apply' | hisUi }}</span></button>
		<button #cancelBtn (click)="closeDialog()" (keydown.tab)="$event.stopPropagation();"><span>{{ 'common.cancel' | hisUi }}</span></button>
	 </p-footer>
</p-dialog>
